module.exports = "/images/checkboxChecked.svg?b353d7090c8b1b1b7c382181fcf15e8c";